<template>
  <div>
    <a-card :title="$t('cardTitle.messageFromTruelifeVisitor')" class="style2">
      <table class="table table-hover table-mail">
        <tbody>
          <tr class="read" v-for="message in messageList" :key="message.id">
            <td class="mail-subject">
              <router-link :to="{ name: 'message', params: { id: message.id } }" v-text="message.subject" />
            </td>
            <td>{{ message.email }}</td>
          </tr>
        </tbody>
      </table>
    </a-card>
  </div>
</template>
<script>
import UserService from '@/services/UserService';
export default {
  created() {
    this.doInitData();
  },
  data() {
    return {
      messageList: [],
    };
  },
  methods: {
    async doInitData() {
      try {
        this.messageList = await UserService.getMessages();
      } catch (error) {
        console.error({ error });
      }
    },
  },
};
</script>
